/**
 * Kategori tontonan di beranda — cerminan `feedCategories` di backend
 * (apps/backend/src/quickplay/categories.ts). Ditulis statis di sini,
 * BUKAN diambil lewat request, supaya chip sudah tampil di frame pertama
 * dan tidak menambah satu round-trip di jalur terpenting aplikasi.
 * Kalau daftar di backend berubah, ubah juga di sini.
 */
export const categories = [
  { id: 'terbaru', label: 'Terbaru' },
  { id: 'populer', label: 'Populer' },
  { id: 'drama-short', label: 'Drama Short' },
  { id: 'drama-series', label: 'Serial Drama' },
  { id: 'anime', label: 'Anime' },
  { id: 'donghua', label: 'Donghua' },
] as const;

export type CategoryId = (typeof categories)[number]['id'];

export const defaultCategory: CategoryId = 'populer';

const byId = new Map<string, string>(categories.map((c) => [c.id, c.label]));

export function categoryLabel(id: string): string {
  return byId.get(id) ?? id;
}
